<template>
    <div class="tweet-actions">
      <img  :src="require('@/assets/tweet/comments.png')" alt="" />
      <img :src="require('@/assets/tweet/retweet.png')" alt="" />
      <img :src="require('@/assets/tweet/like.png')" alt="" />
      <img :src="require('@/assets/tweet/export.png')" alt="" />
    </div>
</template>

<script>
export default {
  name: "TweetActions",
};
</script>

<style lang="scss">
  .tweet-actions {
    display: flex;
    justify-content: space-around;
    align-items: center;
    img {
      width: 10px;
    }
  }
</style>
